import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import Food1 from "../../Assets/Projects/FoodDelivery1.png";
import Food2 from "../../Assets/Projects/FoodDelivery2.png";
import Coffee from "../../Assets/Projects/Coffee.png";
import Car from "../../Assets/Projects/CarRecaption.png";
import Counter from "../../Assets/Projects/CounterAdd.png";
import CURD from "../../Assets/Projects/ReactCRUD.png";
import Password from "../../Assets/Projects/PasswordStrong.png";
import Redux from "../../Assets/Projects/ReduxCart.png";
import Noti from "../../Assets/Projects/NotificationTest.png";




function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Food1}
              isBlog={false}
              title="Food"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="https://github.com/AhtishamUrRehman/food-del"
              demoLink="https://tamatoe-food-delivery.netlify.app/"
            />
          </Col>
           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Food2}
              isBlog={false}
              title="Food"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="https://github.com/AhtishamUrRehman/Food"
              demoLink="https://luminous-pie-52b8c4.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Coffee}
              isBlog={false}
              title="Coffee-Shop"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="https://github.com/AhtishamUrRehman/Coffee-Shop-Website"
              demoLink="https://coffeewebsitewithreact.netlify.app/"
            />
          </Col>
           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Redux}
              isBlog={false}
              title="Redux-Cart"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="https://github.com/AhtishamUrRehman/vite-project"
              demoLink="https://reduxforahtisham.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Car}
              isBlog={false}
              title="Slider"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="https://github.com/AhtishamUrRehman/Car-Reaction"
              demoLink="https://car-reaction.netlify.app/"
            />
          </Col>
           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Noti}
              isBlog={false}
              title="Notifacition-Test"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="https://github.com/AhtishamUrRehman/Notification"
              demoLink="https://notifactiontesting.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Counter}
              isBlog={false}
              title="Counter-Active"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="https://github.com/AhtishamUrRehman/Counter"
              demoLink="https://reactcounteradddata.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={CURD}
              isBlog={false}
              title="Add-Edit-Delete"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="http://github.com/AhtishamUrRehman/List-Delet-Edit"
              demoLink="https://reactcrudaddeditdelete.netlify.app/"
            />
          </Col>
           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Password}
              isBlog={false}
              title="Strong-Password"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="https://github.com/AhtishamUrRehman/Password"
              demoLink="https://imaginative-pie-9ff3a1.netlify.app/"
            />
          </Col>
          

         

          
         

        

         
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
